<template>
   <div class="modal-container has-text-centered">
       <div id="xButt" class="delete is-pulled-right top10" @click="cancel"></div>
         <div class=" bottom20">
           <div class="top40"><img src="@/assets/img/fourDotsLogo.png" width="18"/><div class="is-size-4 is-inline-block"><span class="left3 has-text-white"> BUNDLE GROUPS</span></div></div>
        </div>

        <div v-show="newOrEdit == 'E'" class="select is-coolGreen bottom20">
            <select id="groupsSelect" class="is-size-7"  @change="viewSelected('rowId', $event)">
                <option :value="0" :gName="''">Select...</option>
                <option v-for="(item, i) in $root.app.bundleGroups" :key="i" :value="item.id" :gName="item.name">{{item.name}}</option>
            </select>
            <div class="top5 is-size-7 isUnderlined handCursor" @click="setForNew">+Add Group</div>
        </div>
        <br> <br> 
        
        <div ref="bName" class="editCardTitle is-size-5 has-text-left title" contenteditable="true" @keydown.enter="save"  v-text="groupName"></div>
        <div v-show="showPlaceholder" class="has-text-left" style="margin: 0 50px 0 55px; position: relative; top: 3px; color: #888">Name</div>
        <div class="top10">
            Bundles to include:
        </div>

        <div class="shareTree" :class="{azDisabled: currViewId == 0 && newOrEdit == 'E'}">
             <div class="has-text-left">
               <!--  <share-tree :listName="topBundle.listName" :children="topBundle.children" :depth="0" :id="topBundle.id"></share-tree> -->
               <tree-4-views ref="node" v-for="(item, i) in $root.app.treeNoInbox" :key="i" :listName="item.listName"  :id="item.id"></tree-4-views>
             </div>
        </div>


        <div>
            <div><button class="button is-coolGreen top20" :disabled="((this.currViewId == 0 || localContents.length == 0) && newOrEdit == 'E')" @click="save">Save</button></div>
            <div v-if="this.currViewId != 0">
                <div class="cancelButton top20"  @click="sure = true">Delete</div>
                <span v-show="sure" class="has-text-white is-size-7 top5"><b>Are you Sure?</b>&nbsp;<button class="button is-coolGreen tiny" @click="deleteGroup">YES</button> <button class="button tiny" @click="sure = false">NO</button></span>
            </div>
        </div>
        <br>

   </div>
</template>


<script>

import Tree4Views from '../components/Tree4Views'
import { AZEventBus } from '../components/AZEventBus'

export default{
    props: {
        id: Number,
        branch: Array
    },

    components: {
        Tree4Views
    },

    data: function(){
        return {
            topBundle: {listName: '', children: [], id: 0},
            bundleTree: [],
            blob: [],
            link: false,
            generatedLink: '',
            notes: '', 
            groups: [],
            inView: 0,
            newGroup: false,
            connects: [],
            err: '',
            currViewId: 0,
            localContents: [],
            groupName: '',
            showPlaceholder: true,
            newOrEdit: 'E',
            sure: false
        }
    },

    mounted: function(){

        var self = this

        //buildIt(this.topBundle)


        

        AZEventBus.$on('onViewsTreeNodeClicked', this.onViewsTreeNodeClickedHandler) 

        if(this.$root.app.currBundleGroupId != 0){
           let el = document.getElementById('groupsSelect')
           el.value = this.$root.app.currBundleGroupId
           
           var v = this.$root.app.bundleGroups.find(e => {
               return e.id == this.$root.app.currBundleGroupId
           })

           this.viewSelected(v.name, {target: {value: v.id, selectedOptions:[{attributes:[null, {textContent: v.name}]}]}})
        }
 
    },

    beforeDestroy: function(){
        var self = this;
        AZEventBus.$off('onViewsTreeNodeClicked', this.onViewsTreeNodeClickedHandler) 
    },

    methods: {

        onViewsTreeNodeClickedHandler: function(msg){
            if(msg.selected == true){
                this.localContents.push(msg.id)
            } else {
                var ind = this.localContents.findIndex(e => {
                    return e == msg.id
                })
                this.localContents.splice(ind, 1)
            }
        },

        cancel: function(){
            this.$emit('close')
        },

        viewSelected: function(name, event){
            this.newOrEdit = 'E'

            this.localContents = []

            this.$refs.node.forEach(e => {
                e.isSelected = false
            })
            
            if(event.target.value == 0){
                this.currViewId = 0;
                this.groupName = ''
                return
            }
            this.groupName = event.target.selectedOptions[0].attributes[1].textContent
            this.currViewId = event.target.value
            this.doAutoSelect(event.target.value)   
        },

        doAutoSelect(id){
            var self = this;
            var v = this.$root.app.bundleGroups.find(e => {
                return e.id == id
            })

            let arr = []
            if(typeof(v.contents) == 'string'){
                arr = v.contents.split(',');
            } else {
                arr = v.contents.slice(0)
            }

            arr.forEach(e => {
                self.localContents.push(parseInt(e))
            })

            this.$refs.node.forEach(e => {
                if(self.localContents.includes(e.id)){
                    e.isSelected = true
                } else {
                    e.isSelected = false
                }
            })
        },

        setForNew: function(){
            this.newOrEdit = 'N'
            this.groupName = '';
            this.$refs.bName.textContent = ''
            this.$refs.node.forEach(e => {
                e.isSelected = false
            })
        },

        save: function(){
            var self = this

            if(this.newOrEdit == 'N'){

                if(this.localContents.length == 0 || this.$refs.bName.textContent == ''){
                   
                    return
                }

                function w(d){
                    if(d.r == 'ok'){
                        self.$root.app.bundleGroups.push({id: d.id, name: self.$refs.bName.textContent, contents: self.localContents})
                    }
                    self.cancel()
                }

                function n(){

                }

                this.$root.app.apiClient.post('subs/data/bundlegroup', {name: this.$refs.bName.textContent, contents: this.localContents}, w, n)
            } else {

                if(this.localContents.length == 0 || this.$refs.bName.textContent == ''){
                  
                    return
                }

                function w2(d){
                    
                    if(d.r == 'ok'){
                        var v = self.$root.app.bundleGroups.find(e => {
                            return e.id == self.currViewId
                        })
                        v.name = self.$refs.bName.textContent;
                        v.contents = self.localContents.slice(0)

                        if(self.$root.app.currBundleGroupId == self.currViewId){
                            self.$root.app.currBundleGroup = self.$refs.bName.textContent;
                            self.$root.app.$refs.routerView.viewChanged(self.currViewId, self.$refs.bName.textContent)
                        }
                    }
                    self.cancel()
                }

                function n2(){

                }

                this.$root.app.apiClient.put('subs/data/bundlegroup', {name: this.$refs.bName.textContent, contents: this.localContents, id: this.currViewId}, w2, n2)
            }

      
        },

        deleteGroup: function(){
            var self = this;

            function w(d){
                if(d.r == 'ok'){
                    var ind = self.$root.app.bundleGroups.findIndex(e => {
                        return e.id == self.currViewId
                    })

                    self.$root.app.bundleGroups.splice(ind, 1);

                    if(self.$root.app.currBundleGroupId == self.currViewId){
                        self.$root.app.currBundleGroup = 'All'
                        self.$root.app.$refs.routerView.viewChanged(0, 'All')
                    }
                    
                }

                self.cancel()
            }

            function n(){

            }

            this.$root.app.apiClient.delete('subs/data/bundlegroup', {id: this.currViewId}, w, n)
             
        }
      
    }

}
</script>


<style scoped>
    .modal-container{
        max-width: 400px;
    }

    .title{
        margin: 0 50px 0 50px
    }
    #xButt{
        background-color: transparent !important;
        position: absolute;
        font-size: 2rem !important;
        right: 10px;
    }

  
    .delete::after{
        width: 1px;
        height: 100%
    }
     .delete::before{
        height: 1px;
        width: 100%
    }
</style>